export { u as useBreakpoints, a as useCalendar, b as useI18n, c as useId } from './useBreakpoints-Cx1EETam.js';
export { u as useClipboard, a as useDeprecated, d as useGroupData, b as useModal, c as useNotifier, e as useStackingGroup, f as useStackingItem } from './useStackingItem-DFvE8bpP.js';
import { useUrlSearchParams as useUrlSearchParams$1, useStorage } from '@vueuse/core';
import { ref, watch, toValue, unref, toRef, computed, onMounted, nextTick, toRaw } from 'vue';
import { d as debounce } from './groupData-Dl8C-s_B.js';
import { d as deepCopy, u as useLocale, s as safeIsEqual } from './deepCopy-BPIPBkff.js';
export { a as useDayjs } from './deepCopy-BPIPBkff.js';
import 'uuid';
import { useRoute } from 'vue-router';
import { i as isObject, a as arrayDiff } from './arrayDiff-DwhGsjcf.js';
export { u as useSingleton } from './useSingleton-D8gLr_EB.js';

function mitt(n){return {all:n=n||new Map,on:function(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e]);},off:function(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]));},emit:function(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e);}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e);});}}}

const paramsInstances = /* @__PURE__ */ new Map();
function useUrlSearchParams(preserve = true) {
  const key = window.location.pathname;
  if (!preserve || !paramsInstances.has(key))
    paramsInstances.set(key, useUrlSearchParams$1());
  return paramsInstances.get(key);
}

function loadStartDateParamToState({ value, state }) {
  state.value.dateRange.start = value;
}
function loadEndDateParamToState({ value, state }) {
  state.value.dateRange.end = value;
}
function loadGroupParamToState({ value, state }) {
  state.value.groupBy = value.split(",");
}
function loadColumnParamToState({ value, state }) {
  state.value.visibleColumns = value.split(",");
}
function loadTotalParamToState({ value, state }) {
  state.value.totalBy = value;
}
function loadSortParamToState({ value, state }) {
  state.value.sortBy = [...value.matchAll(/(?<sign>-)?(?<key>[a-z]+)(,)?/g)].map((match) => match.groups).map(({ key, sign }) => ({ key, direction: sign === "-" ? "desc" : "asc" }));
}
function loadPageParamToState({ value, state }) {
  state.value.pagination.currentPage = +value;
}
function loadFilterParamToState({ key, value, state, type }) {
  if (type === String) {
    state.value.filters[key] = value;
    return;
  }
  if (type === Array) {
    state.value.filters[key] = value.split(",");
    return;
  }
  if (type === Number) {
    state.value.filters[key] = +value;
    return;
  }
  if (type === Boolean) {
    state.value.filters[key] = value === "true";
    return;
  }
  if (typeof type === "function")
    state.value.filters[key] = type(value);
}
function useDataQueryStore(uniqueKey, {
  initialState = {},
  enabled = true,
  debounce: debounce$1 = true,
  persist = false,
  urlSearchParams = useUrlSearchParams(),
  enableParams = true,
  enableSortBy = true,
  enablePaging = true,
  enableDateRange = true,
  enableFilters = true,
  enableGroupBy = true,
  enableTotalBy = true,
  enableColumns = true,
  filterParams = {},
  onUpdate,
  storageProvider
} = {}) {
  if (!uniqueKey) {
    console.error("useDataQueryStore: uniqueKey cannot be empty");
    return {};
  }
  const enabledRef = ref(enabled);
  const emptyState = {
    ...enableDateRange && { dateRange: { start: void 0, end: void 0 } },
    ...enableFilters && { filters: {} },
    ...enableGroupBy && { groupBy: [] },
    ...enablePaging && { pagination: {} },
    ...enableSortBy && { sortBy: [] },
    ...enableTotalBy && { totalBy: void 0 },
    ...enableColumns && { visibleColumns: [] }
  };
  const defaultStorageProvider = (uniqueKey2, initialState2) => {
    return useStorage(
      uniqueKey2,
      initialState2,
      localStorage,
      {
        serializer: {
          read: (v) => v ? JSON.parse(v) : null,
          write: (v) => JSON.stringify(v)
        }
      }
    );
  };
  storageProvider = storageProvider || defaultStorageProvider;
  const initializeState = (initialState2) => {
    if (!persist) {
      return ref(initialState2);
    } else {
      return storageProvider(
        uniqueKey,
        initialState2
      );
    }
  };
  const loadParamsToState = ({ urlSearchParams: urlSearchParams2, state: state2 }) => {
    if (!enableParams)
      return;
    Object.entries(urlSearchParams2).forEach(([key, value]) => {
      if (value === "")
        return;
      switch (key) {
        case "startdate":
          if (enableDateRange)
            loadStartDateParamToState({ value, state: state2 });
          break;
        case "enddate":
          if (enableDateRange)
            loadEndDateParamToState({ value, state: state2 });
          break;
        case "group":
          if (enableGroupBy)
            loadGroupParamToState({ value, state: state2 });
          break;
        case "columns":
          if (enableColumns)
            loadColumnParamToState({ value, state: state2 });
          break;
        case "total":
          if (enableTotalBy)
            loadTotalParamToState({ value, state: state2 });
          break;
        case "sort":
          if (enableSortBy)
            loadSortParamToState({ value, state: state2 });
          break;
        case "page":
          if (enablePaging)
            loadPageParamToState({ value, state: state2 });
          break;
        default:
          if (enableFilters) {
            const filterParam = filterParams[key];
            if (filterParam)
              loadFilterParamToState({ key, value, state: state2, type: filterParam });
          }
          break;
      }
    });
  };
  let skipNextUpdate = false;
  function getActions(state2) {
    const set = (state3) => {
      state3.value = { ...emptyState, ...state3 };
    };
    const reset = () => {
      set({
        ...emptyState
      });
    };
    const updatePage = (pageNumber) => {
      state2.value.pagination.currentPage = +pageNumber;
    };
    const updatePageSize = (pageSize) => {
      state2.value.pagination.perPage = +pageSize;
      updatePage(1);
    };
    const setPagination = ({ count, currentPage, perPage, totalPages }) => {
      skipNextUpdate = true;
      state2.value.pagination = {
        count,
        currentPage,
        perPage,
        totalPages
      };
    };
    const setDateRange = (dateRange) => {
      state2.value.dateRange = { ...dateRange };
      if (enablePaging)
        updatePage(1);
    };
    const updateFilter = ({ key, value }) => {
      if (value !== void 0 && !(Array.isArray(value) && value.length === 0))
        state2.value.filters[key] = value;
      else delete state2.value.filters[key];
      if (enablePaging)
        updatePage(1);
    };
    const setFilters = (filters) => {
      state2.value.filters = { ...filters };
      if (enablePaging)
        updatePage(1);
    };
    const setGroupBy = (groupBy) => {
      state2.value.groupBy = [...groupBy];
      if (enablePaging)
        updatePage(1);
    };
    const updateSortBy = (key) => {
      if (state2.value.sortBy[0]?.key === key) {
        state2.value.sortBy[0].direction = state2.value.sortBy[0].direction === "asc" ? "desc" : "asc";
        return;
      }
      state2.value.sortBy = state2.value.sortBy.filter((entry) => entry.key !== key);
      state2.value.sortBy.unshift({ key, direction: "asc" });
      if (enablePaging)
        updatePage(1);
    };
    const setSortBy = (sortBy) => {
      state2.value.sortBy = [...sortBy];
      if (enablePaging)
        updatePage(1);
    };
    const resetSortBy = () => {
      setSortBy([]);
    };
    const setTotalBy = (totalBy) => {
      state2.value.totalBy = totalBy;
      if (enablePaging)
        updatePage(1);
    };
    const setVisibleColumns = (visibleColumns) => {
      state2.value.visibleColumns = [...visibleColumns];
    };
    return {
      set,
      reset,
      ...enablePaging && {
        updatePage,
        updatePageSize,
        setPagination
      },
      ...enableDateRange && { setDateRange },
      ...enableFilters && {
        updateFilter,
        setFilters
      },
      ...enableGroupBy && { setGroupBy },
      ...enableSortBy && {
        updateSortBy,
        setSortBy,
        resetSortBy
      },
      ...enableTotalBy && { setTotalBy },
      ...enableColumns && { setVisibleColumns }
    };
  }
  const syncStateToParams = ({ state: state2, urlSearchParams: urlSearchParams2 }) => {
    if (!enableParams)
      return;
    if (enableDateRange) {
      watch(
        () => state2.value.dateRange.start,
        (value) => {
          urlSearchParams2.startdate = value;
        }
      );
      watch(
        () => state2.value.dateRange.end,
        (value) => {
          urlSearchParams2.enddate = value;
        }
      );
    }
    if (enableGroupBy) {
      watch(
        () => state2.value.groupBy,
        (value) => {
          urlSearchParams2.group = value.join(",");
        },
        { deep: true }
      );
    }
    if (enableSortBy) {
      watch(
        () => state2.value.sortBy,
        (value) => {
          urlSearchParams2.sort = value.map(({ key, direction }) => `${direction === "desc" ? "-" : ""}${key}`).join(",");
        },
        { deep: true }
      );
    }
    if (enablePaging) {
      watch(
        () => state2.value.pagination.currentPage,
        (value) => {
          urlSearchParams2.page = value;
        }
      );
    }
    if (enableTotalBy) {
      watch(
        () => state2.value.totalBy,
        (value) => {
          urlSearchParams2.total = value;
        }
      );
    }
    if (enableColumns) {
      watch(
        () => state2.value.visibleColumns,
        (value) => {
          urlSearchParams2.columns = value.join(",");
        },
        { deep: true }
      );
    }
    if (enableFilters) {
      watch(
        () => state2.value.filters,
        (value) => {
          Object.entries(value).forEach(([key, value2]) => {
            if (!Object.keys(filterParams).includes(key))
              return;
            if (Array.isArray(value2))
              urlSearchParams2[key] = value2.join(",");
            else
              urlSearchParams2[key] = value2;
          });
        },
        { deep: true }
      );
    }
  };
  const state = initializeState(
    {
      ...emptyState,
      ...initialState
    }
  );
  loadParamsToState({ urlSearchParams, state });
  const actions = getActions(state);
  const bus = mitt();
  const update = () => {
    if (!toValue(enabledRef))
      return;
    const updateParams = { state: deepCopy(unref(state)), setPagination: actions.setPagination };
    if (typeof onUpdate === "function")
      onUpdate(updateParams);
    bus.emit("query-updated", updateParams);
  };
  const debouncedUpdate = debounce(update, 250);
  watch(
    () => [state.value, enabledRef.value],
    () => {
      if (skipNextUpdate) {
        skipNextUpdate = false;
        return;
      }
      if (debounce$1)
        debouncedUpdate();
      else update();
    },
    { deep: true, immediate: true }
  );
  syncStateToParams({ state, urlSearchParams });
  return { actions, bus, state, enabled: enabledRef };
}

const { locale } = useLocale();
function useLocaleWatcher(callback) {
  if (!callback)
    return;
  watch(locale, () => {
    callback();
  });
}

function useRoutePath() {
  const route = useRoute();
  if (route) {
    return {
      routePath: toRef(() => route.path),
      isRouterPath: true
    };
  }
  return {
    routePath: ref(window.location.pathname),
    isRouterPath: false
  };
}

function getOptionValue(option) {
  return option?.value || option;
}
function useSelection({ options, value, allowDeselection = true }) {
  const isMultiple = computed(() => Array.isArray(value.value));
  const normalizedOptions = computed(() => {
    const optionsValue = toValue(options);
    if (!optionsValue)
      return [];
    return optionsValue?.map(
      (option) => isObject(option) ? option : {
        value: option,
        label: option
      }
    );
  });
  const allNonDisabledOptions = computed(() => {
    return normalizedOptions.value.filter((option) => option.disabled !== true);
  });
  const isSelectedSingle = (option) => safeIsEqual(value.value, getOptionValue(option));
  const isSelectedMultiple = (option) => value.value?.includes(getOptionValue(option));
  const isSelected = (option) => isMultiple.value ? isSelectedMultiple(option) : isSelectedSingle(option);
  const selectSingle = (option) => {
    if (option.disabled === true)
      return;
    value.value = getOptionValue(option);
  };
  const isAllNonDisabledOptionsSelected = computed(() => {
    if (!isMultiple.value)
      return false;
    return allNonDisabledOptions.value.every((option) => isSelected(option));
  });
  const selectMultiple = (option) => {
    if (option.disabled === true)
      return;
    value.value?.push(getOptionValue(option));
  };
  const select = (option) => {
    if (isMultiple.value)
      selectMultiple(option);
    else selectSingle(option);
  };
  const deselectSingle = (option) => {
    if (option.disabled === true)
      return;
    if (!allowDeselection)
      return;
    value.value = null;
  };
  const deselectMultiple = (option) => {
    if (option.disabled === true)
      return;
    if (!allowDeselection)
      return;
    const index = value.value?.indexOf(getOptionValue(option));
    if (index !== -1)
      value.value?.splice(index, 1);
  };
  const deselect = (option) => {
    if (isMultiple.value)
      deselectMultiple(option);
    else deselectSingle(option);
  };
  const selectAll = () => {
    allNonDisabledOptions.value.forEach((option) => {
      if (!isSelected(option))
        select(option);
    });
  };
  const deselectAll = () => {
    allNonDisabledOptions.value.forEach((option) => deselect(option));
  };
  const toggleSelectAll = () => {
    if (isAllNonDisabledOptionsSelected.value)
      deselectAll();
    else selectAll();
  };
  const toggle = (option) => {
    if (isSelected(option))
      deselect(option);
    else select(option);
  };
  return {
    isSelected,
    isMultiple,
    toggle,
    toggleSelectAll,
    isAllSelected: isAllNonDisabledOptionsSelected
  };
}

function useTrackedArray({
  fetch,
  onUpdate,
  onError = (error) => {
    throw error;
  },
  updateDebounceMs = 500,
  comparator = (a, b) => a.id === b.id,
  includeModified = true
}) {
  const loading = ref(false);
  const savedArray = ref([]);
  const array = ref([]);
  const dirty = ref(false);
  const updates = ref(0);
  const load = async () => {
    loading.value = true;
    try {
      const data = await fetch();
      savedArray.value = data;
      array.value = deepCopy(data);
    } catch (error) {
      onError(error);
    } finally {
      loading.value = false;
    }
    await nextTick();
    dirty.value = false;
    loading.value = false;
  };
  const handleUpdate = async () => {
    const diffArray = arrayDiff(toRaw(savedArray.value), toRaw(array.value), { comparator, includeModified });
    await onUpdate({ refresh: load, diffArray });
  };
  const debouncedHandleUpdate = updateDebounceMs ? debounce(handleUpdate, updateDebounceMs) : handleUpdate;
  watch(
    updates,
    () => {
      dirty.value = true;
      debouncedHandleUpdate();
    }
  );
  onMounted(async () => {
    await load();
    watch(
      array,
      () => updates.value++,
      { deep: true }
    );
  });
  return {
    loading,
    array,
    dirty,
    refresh: load
  };
}

export { useDataQueryStore, useLocale, useLocaleWatcher, useRoutePath, useSelection, useTrackedArray, useUrlSearchParams };
//# sourceMappingURL=composables.js.map
